import { render } from "./Label.vue?vue&type=template&id=2d52f385"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"
script.render = render

export default script